export default {
  tags: {
    h1: {
      start: "#",
      end: ""
    },
    h2: {
      start: "##",
      end: ""
    },
    h3: {
      start: "###",
      end: ""
    },
    bold: {
      start: "**",
      end: "**"
    },
    italic: {
      start: "_",
      end: "_"
    },
    underline: {
      start: "<u>",
      end: "</u>"
    },
    superscript: {
      start: "<sup>",
      end: "</sup>"
    },
    subscript: {
      start: "<sub>",
      end: "</sub>"
    },
    math: {
      start: "$",
      end: "$"
    }
  }
};
